var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeSlash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2699 9.18029C20.9799 8.72029 20.6699 8.29029 20.3499 7.89029C19.9799 7.42029 19.2799 7.38029 18.8599 7.80029L15.8599 10.8003C16.0799 11.4603 16.1199 12.2203 15.9199 13.0103C15.5699 14.4203 14.4299 15.5603 13.0199 15.9103C12.2299 16.1103 11.4699 16.0703 10.8099 15.8503C10.8099 15.8503 9.37995 17.2803 8.34995 18.3103C7.84995 18.8103 8.00995 19.6903 8.67995 19.9503C9.74995 20.3603 10.8599 20.5703 11.9999 20.5703C13.7799 20.5703 15.5099 20.0503 17.0899 19.0803C18.6999 18.0803 20.1499 16.6103 21.3199 14.7403C22.2699 13.2303 22.2199 10.6903 21.2699 9.18029Z",
    fill: "#1C1C1A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0201 9.97965L9.98014 14.0196C9.47014 13.4996 9.14014 12.7796 9.14014 11.9996C9.14014 10.4296 10.4201 9.13965 12.0001 9.13965C12.7801 9.13965 13.5001 9.46965 14.0201 9.97965Z",
    fill: "#1C1C1A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.25 5.74969L14.86 9.13969C14.13 8.39969 13.12 7.95969 12 7.95969C9.76 7.95969 7.96 9.76969 7.96 11.9997C7.96 13.1197 8.41 14.1297 9.14 14.8597L5.76 18.2497H5.75C4.64 17.3497 3.62 16.1997 2.75 14.8397C1.75 13.2697 1.75 10.7197 2.75 9.14969C3.91 7.32969 5.33 5.89969 6.91 4.91969C8.49 3.95969 10.22 3.42969 12 3.42969C14.23 3.42969 16.39 4.24969 18.25 5.74969Z",
    fill: "#1C1C1A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8601 12.0001C14.8601 13.5701 13.5801 14.8601 12.0001 14.8601C11.9401 14.8601 11.8901 14.8601 11.8301 14.8401L14.8401 11.8301C14.8601 11.8901 14.8601 11.9401 14.8601 12.0001Z",
    fill: "#1C1C1A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7699 2.22988C21.4699 1.92988 20.9799 1.92988 20.6799 2.22988L2.22988 20.6899C1.92988 20.9899 1.92988 21.4799 2.22988 21.7799C2.37988 21.9199 2.56988 21.9999 2.76988 21.9999C2.96988 21.9999 3.15988 21.9199 3.30988 21.7699L21.7699 3.30988C22.0799 3.00988 22.0799 2.52988 21.7699 2.22988Z",
    fill: "#1C1C1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeSlash);
export default __webpack_public_path__ + "static/media/eye-slash.9c8ee0fef49778126eb90e02b8b486f7.svg";
export { ForwardRef as ReactComponent };